// extracted by mini-css-extract-plugin
export var card = "_9m5q-";
export var phone = "RWa8m";
export var phoneChrome = "_5DIie";
export var root = "FVcCy";